export { MyV3HomeContainer as default } from "containers/MyV3Container";
